"use client";
import React, { useState } from "react";
import { Button } from "ui/components/button";
import { Popover, PopoverContent, PopoverTrigger } from "ui/components/popover";
import { MonthRangePicker } from "ui/components/monthrangepicker";
import { CALENDAR, X } from "icons/src";
import { format } from "date-fns";
import { cn } from "ui/lib/utils";
import { Icon } from "components/index";

export function MonthRangePickerButton({
  selectedMonthRange,
  onMonthRangeSelect,
  placeholder = "Select month range",
  className,
  buttonClassName,
  showQuickSelectors = true,
  disabled = false,
  ...props
}) {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const handleMonthRangeSelect = (range) => {
    if (!range) {
      onMonthRangeSelect?.(null);
      setIsPopoverOpen(false);
      return;
    }

    // Create proper date range: start of start month to end of end month
    const startDate = new Date(
      range.start.getFullYear(),
      range.start.getMonth(),
      1
    );
    const endDate = new Date(
      range.end.getFullYear(),
      range.end.getMonth() + 1,
      0
    ); // Last day of end month

    const properRange = {
      start: startDate,
      end: endDate,
    };

    onMonthRangeSelect?.(properRange);
    setIsPopoverOpen(false); // Close popover after selection
  };

  const handleClear = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onMonthRangeSelect?.(null);
    setIsPopoverOpen(false);
  };

  const getDisplayText = () => {
    if (selectedMonthRange?.start && selectedMonthRange?.end) {
      return `${format(selectedMonthRange.start, "MMM yyyy")} - ${format(
        selectedMonthRange.end,
        "MMM yyyy"
      )}`;
    }
    return placeholder;
  };

  return (
    <div className={cn("", className)} {...props}>
      <Popover open={isPopoverOpen} onOpenChange={setIsPopoverOpen}>
        <PopoverTrigger asChild>
          <Button
            variant="outline"
            disabled={disabled}
            className={cn(
              "w-[280px] justify-start text-left font-normal",
              !selectedMonthRange && "text-muted-foreground",
              buttonClassName
            )}
          >
            <Icon icon={CALENDAR} className="mr-2 h-4 w-4" />

            <span className="flex-1">{getDisplayText()}</span>
            {selectedMonthRange?.start && selectedMonthRange?.end && (
              <div onClick={handleClear}>
                <Icon
                  icon={X}
                  className="ml-2 h-4 w-4 cursor-pointer hover:text-destructive"
                />
              </div>
            )}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <MonthRangePicker
            selectedMonthRange={selectedMonthRange}
            onMonthRangeSelect={handleMonthRangeSelect}
            showQuickSelectors={showQuickSelectors}
          />
        </PopoverContent>
      </Popover>
    </div>
  );
}
